import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { Select, Store } from '@ngxs/store';
import { ViewState } from '../../state/view.state';
import { Observable } from 'rxjs';
import { ViewActions } from '../../state/view.actions';
import { ViewService } from '../../view.service';
import { Fullscreen } from 'src/app/shared/libraries/fullscreen/fullscreen';
import { HelpTypeEnum } from '../../models/help-type.enum';
import { ViewUIStatus } from '../../models/view-ui-status.enum';
import { EngineState } from 'src/app/engine/state/engine.state';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { ChapterReadyStateModel } from 'src/app/story/models/chapter-ready-state.model';

@Component({
  selector: 'app-view-menu-column',
  templateUrl: './view-menu-column.component.html',
  styleUrls: ['./view-menu-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ 
          transform: 'translateX(320px)'
        }),
        animate('200ms ease-out', style({ 
          transform: '*'
        }))
      ]),
      transition(':leave', [
        animate('200ms', style({ 
          transform: 'translateX(320px)'
        }))
      ])
    ])
  ]
})
export class ViewMenuColumnComponent implements OnInit {
  
  @Select(StoryChaptersState.getSelectedChapterReadyState)
  selectedChapterReady$: Observable<ChapterReadyStateModel>;  

  @Select(ViewState.getMenuOpen)
  menuOpen$: Observable<boolean>;

  @Select(ViewState.getCanTouch)
  canTouch$: Observable<boolean>;

  @Select(EngineState.getShowLabels)
  showLabels$: Observable<boolean>;

  constructor(
    private store: Store,
    private viewService: ViewService
  ) { }

  ngOnInit() {
  }

  handleCloseClick() {
    this.store.dispatch(new ViewActions.ToggleMenu(false));
  }

  handleToggleLabelsClick() {
    this.viewService.toggleLabels();
  }

  handleFullscreenClick() {
    this.handleCloseClick();
    Fullscreen.toggleFullscreen();
  }

  handleNewTabClick() {
    this.handleCloseClick();
    this.viewService.openInNewTab();
  }

  handleSearchClick() {
    this.handleCloseClick();
    this.viewService.toggleSearch();
  }

  handleTutorialClick() {
    this.handleCloseClick();
    this.viewService.toggleTutorial(true);
  }

  handleHelpBasicsClick() {
    this.handleCloseClick();
    this.viewService.toggleHelp(true, HelpTypeEnum.Basics);
  }

  handleHelpShortcutsClick() {
    this.handleCloseClick();
    this.viewService.toggleHelp(true, HelpTypeEnum.Shortcuts);
  }

  handleToggleToolbar(bar: 'media' | 'tools' | 'toolbar') {
    this.handleCloseClick();

    const layout = this.store.selectSnapshot(ViewState.getUI);
    layout.media.status = ViewUIStatus.Hide;
    layout.tools.status = ViewUIStatus.Hide;
    layout.toolbar.status = ViewUIStatus.Hide;
    layout[bar].status = ViewUIStatus.Show;
    this.store.dispatch(new ViewActions.SetUI(layout));
  }

}
